import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { Designation } from './employees.model';
import { PaginatedResponse } from '../common/models/common.model';

@Injectable({
  providedIn: 'root',
})
export class DesignationService {
  private _baseUrl: string = 'designations/';

  constructor(private _apiService: ApiService) {}

  list(): Observable<Designation[]> {
    return this._apiService.get(this._baseUrl);
  }

  create(body: { title: string }): Observable<Designation> {
    return this._apiService.post(this._baseUrl, body);
  }

  update(id: string, body: Partial<{ title: string }>): Observable<Designation> {
    return this._apiService.patch(`${this._baseUrl}${id}/`, body);
  }

  delete(id: string): Observable<void> {
    return this._apiService.delete(`${this._baseUrl}${id}/`);
  }
}
